import i18n from "../i18n";

/**
 * 1:sql/redis语句错误;
 * 2:用户不存在;
 * 3:密码错误;
 * 4:用户ID不存在;
 * 5:redis用户未登录；
 * 6:redis用户超时;
 * 7:用户正在使用;
 * 8:用户已登录;
 * 9:邀请码不存在;
 * 10:验证码过期;
 * 11:验证码错误;
 * 12:邀请码已注册;
 * 13:验证码发送失败;
 * 14:user_token错误;
 * 15:请求模型错误;
 * 16:请求session_id失败;
 * 17:参数错误;
 * 18:用户已被注册;
 * 22:用户注册，等待审核中;
 */

export enum ResCode {
  Success = 0,
  UserNotExist = 2,
  PasswordNotAccess = 3,
  UserNotLogin = 5,
  UserOperating = 7,
  InviteCodeNotExist = 9,
  SmsCodeExpired = 10,
  SmsCodeInvalid = 11,
  InviteCodeUsed = 12,
  TokenInvalid = 14,
  AlreadyRegister = 18,
  UserWaitVerify = 22,
}

export const HTTP_STATUS: { [key: string]: number } = {
  SUCCESS: 200,
  CREATED: 201,
  ACCEPTED: 202,
  CLIENT_ERROR: 400,
  AUTHENTICATE: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
};

// ‘对话数据用于优化模型’开关
export enum MODEL_SWITCH {
  ABLE = "able",
  DISABLED = "disable",
}

// export const PATH_PREFIX = `${BUSINESS_ENV.indexOf("preview") > -1 ? "/preview" : ""}/api`;
export const PATH_PREFIX = "/api";
export const SERVER_BUSY_TOAST = i18n.t("sensechat-125"); // "服务器要被挤爆啦，请稍后再体验";
export const REQUEST_ERR_TOAST = i18n.t("sensechat-84"); // "请求失败";
